import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PageRegionsNew } from '@/components/admin/regions/PageRegionsNew'
import { optionalSearchString } from '@/lib/searchParamsSchema'
import { getAdminRegionNewLoaderFn } from '@/server/admin/admin.functions'

const SearchSchema = z.object({
  slug: optionalSearchString(),
})

export const Route = createFileRoute('/admin/regions/new')({
  ssr: true,
  validateSearch: (search) => SearchSchema.parse(search),
  loader: async () => await getAdminRegionNewLoaderFn(),
  head: () => ({
    meta: [{ title: 'Neue Region – ADMIN TILDA' }],
  }),
  component: PageRegionsNew,
})
